import { useEffect, useRef } from 'react';
import './EnergyBallAnimation.css';

export default function EnergyBallAnimation({ onComplete, playerRef, opponentRef }) {
  const elementsRef = useRef([]);

  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const container = playerEl.parentElement;
    const pRect = playerEl.getBoundingClientRect();
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();

    const startX = pRect.left - cRect.left + pRect.width / 2;
    const startY = pRect.top - cRect.top + pRect.height / 2;
    const endX = oRect.left - cRect.left + oRect.width / 2;
    const endY = oRect.top - cRect.top + oRect.height / 2;

    const elements = [];

    // Phase 1: Charging Animation
    const chargeTime = 800;
    for (let i = 0; i < 15; i++) {
      const particle = document.createElement('div');
      particle.className = 'energy-ball-charge-particle';
      particle.style.left = `${startX}px`;
      particle.style.top = `${startY}px`;
      const angle = Math.random() * 360;
      const radius = 50 + Math.random() * 20;
      particle.style.setProperty('--angle', `${angle}deg`);
      particle.style.setProperty('--radius', `${radius}px`);
      particle.style.animationDelay = `${Math.random() * 0.4}s`;
      container.appendChild(particle);
      elements.push(particle);
    }

    // Phase 2: Ball Travel
    const travelTime = 500;
    const ballTimer = setTimeout(() => {
      const ball = document.createElement('div');
      ball.className = 'energy-ball-main';
      ball.style.left = `${startX}px`;
      ball.style.top = `${startY}px`;
      ball.style.setProperty('--tx', `${endX - startX}px`);
      ball.style.setProperty('--ty', `${endY - startY}px`);
      container.appendChild(ball);
      elements.push(ball);
    }, chargeTime);

    // Phase 3: Impact
    const impactTime = chargeTime + travelTime;
    const impactTimer = setTimeout(() => {
      opponentEl.classList.add('energy-ball-hit');

      const impactBlast = document.createElement('div');
      impactBlast.className = 'energy-ball-impact';
      impactBlast.style.left = `${endX}px`;
      impactBlast.style.top = `${endY}px`;
      container.appendChild(impactBlast);
      elements.push(impactBlast);

      for (let i = 0; i < 20; i++) {
        const leaf = document.createElement('div');
        leaf.className = 'energy-ball-leaf-particle';
        leaf.style.left = `${endX}px`;
        leaf.style.top = `${endY}px`;
        const angle = Math.random() * 360;
        const distance = 90 + Math.random() * 40;
        leaf.style.setProperty('--dx', `${Math.cos(angle * Math.PI / 180) * distance}px`);
        leaf.style.setProperty('--dy', `${Math.sin(angle * Math.PI / 180) * distance}px`);
        leaf.style.setProperty('--rotation', `${Math.random() * 360}deg`);
        leaf.style.animationDelay = `${Math.random() * 0.15}s`;
        container.appendChild(leaf);
        elements.push(leaf);
      }
    }, impactTime);

    // Cleanup
    const cleanupTime = impactTime + 1200;
    const cleanupTimer = setTimeout(() => {
      elements.forEach(el => el.remove());
      opponentEl.classList.remove('energy-ball-hit');
      onComplete();
    }, cleanupTime);

    elementsRef.current = elements;

    return () => {
      clearTimeout(ballTimer);
      clearTimeout(impactTimer);
      clearTimeout(cleanupTimer);
      elementsRef.current.forEach(el => el.remove());
      if (opponentEl) opponentEl.classList.remove('energy-ball-hit');
    };
  }, [onComplete, playerRef, opponentRef]);

  return null;
}

EnergyBallAnimation.moveType = 'grass';
